import AbstractComponent from './AbstractComponent';
// import { OPENED } from 'core/Classes';

class Accordion extends AbstractComponent {
	constructor() {
		super(...arguments);
	}

	bind() {
		super.bind();
	}

	getUI() {
		const ui = super.getUI();
		ui.$toggles = [...ui.$element.querySelectorAll('.accordion__toggle')];
		ui.$panels = [...ui.$element.querySelectorAll('.accordion__panel')];
		return ui;
	}

	events(listen) {
		const listener = listen ? 'addEventListener' : 'removeEventListener';
		this.ui.$toggles.forEach($expand => $expand[listener]('click', this.handleClickExpand));
	}

	handleClickExpand(event) {
		const $element = event.currentTarget;
		const $panel = $element.closest('.accordion__item').querySelector('.accordion__panel');
		const isExpanded = $element.getAttribute('aria-expanded') === 'true';
		$element.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
		$panel.setAttribute('aria-hidden', isExpanded ? 'true' : 'false');
	}
}

export default Accordion;
